<div id="manage-customer" class="subBlockContainer managesubscriptiondetails" style="flex-shrink: 0; width: unset;">
    <mat-sidenav-container class="sidenav-container" style="height: 100%; position: unset;background: white;" [hasBackdrop]="false">
      <div style="flex-direction: column; height: 100%; width: 1145px" *ngIf="!narrowMode">
        <child-header [title]="customer?.companyName" (closeEvent)="close()"></child-header>
        <div class="subBlockContent" style="margin-left: unset;">
          <div class="item-title-wrapper" style="background: unset;">

            <!-- customer detail -->
            <mat-accordion multi *ngIf="!narrowMode">
              <!-- Customer info -->
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="highlight-text"> CUSTOMER DETAILS </mat-panel-title>
                  <mat-panel-description class="panel-subtitle">
                    <span class="highlight-text"> NAME:&nbsp; </span><span>{{ customer?.companyName }}</span>
                    <span class="highlight-text"> CUSTOMER ID:&nbsp; </span><span>{{ customer?.id }}</span>
                  </mat-panel-description>
                </mat-expansion-panel-header>
      
                <div style="font-size: 12px;">
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-sm">
                        <label class="lable-title">NAME</label>
                        <p class="paragraph-text">{{ customer?.companyName }}</p>
                      </div>
                      <div class="col-sm">
                        <label class="lable-title">FIRST AND LAST NAME</label>
                        <p class="paragraph-text">{{ customer?.fullName }}</p>
                      </div>
                      <!-- <div class="col-sm">
                        <label class="lable-title">STATUS</label>
                        <p class="paragraph-text">{{ details?.customer?.out_status_desc }}</p>
                      </div> -->
                    </div>
                    <div class="row">
                      <div class="col-sm">
                        <label class="lable-title">Customer ID / CONTRACT</label>
                        <p class="paragraph-text">{{ customer?.id }}</p>
                      </div>
                      <div class="col-sm">
                        <label class="lable-title">PHONE</label>
                        <p class="paragraph-text">{{ customer?.phone }}</p>
                      </div>
                      <!-- <div class="col-sm">
                        <label class="lable-title">NEXT BILLING DATE</label>
                        <p class="paragraph-text">{{ details?.customer?.out_next_billing_date }}</p>
                      </div> -->
                    </div>
                    <div class="row">
                      <!-- <div class="col-sm">
                        <label class="lable-title">TENANT DESCRIPTION</label>
                        <p class="paragraph-text">{{ details?.customer?.out_tenant_desc }}</p>
                      </div> -->
                      <div class="col-sm">
                        <label class="lable-title">EMAIL</label>
                        <p class="paragraph-text">{{ customer?.email }}</p>
                      </div>
                      <div class="col-sm">
                        <label class="lable-title">ADDRESS</label>
                        <p class="paragraph-text" class="paragraph-text">{{ customer?.addressLine1 }} {{
                          customer?.addressLine2 }} {{ customer?.addressLine3 }} {{
                          customer?.suburb}}, {{ customer?.state }} {{
                          customer?.postcode
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <button 
                          [disabled]="!authService?.currentUserHasPurchaseAccess()"
                          [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                          matTooltip="Requires Purchasing Permissions"
                          class="button button-red button-mid edit-enduser"
                          (click)="editCustomerDetail($event)"
                        >Edit Customer</button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
      
            </mat-accordion>

            <!-- list -->
            <div *ngIf="!loadingPrograms;else customerProgramsSpinner" class="child-body">
                <!-- filter -->
                <div class="inner-subBlock-wrapper row" style="margin: 20px 20px 0px 20px;">
                  <div class="filter-wrapper">
                      <div class="col-md-3">
                          <div class="searchInputGroup toplevelsub" [class.narrowModeInput]="narrowMode">
                              <div class="searchIcon">
                                  <img src="../images/new_ui/filter.png">
                              </div>
                              <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                          </div>
                      </div>
                  </div>

                  <div class="migrate-all-button">
                    <button class="button button-red button-round" (click)="enrollProgramEvent()">
                        &nbsp;Enroll Into a Subscription Program
                        &nbsp;
                    </button>
                </div>
              </div>
              <div >
                  <div class="noData-wrapper" *ngIf="!customerPrograms.length">
                      <div>
                          <img src="../images/new_ui/no-subscription.png">
                      </div>
                      <label class="noData-label">
                          We couldn't find any <br />
                          enrolled programs
                      </label>
                  </div>

                  
                  <ng-container *ngIf="customerPrograms.length">
                      <table  mat-table matSort [dataSource]="dataSource">
                          <ng-container matColumnDef="programName">
                              <th mat-header-cell *matHeaderCellDef style="width: 1017px; "> Active </th>
                              <td mat-cell *matCellDef="let customer" style="width: 1017px;"> {{ customer?.programType }} </td>
                          </ng-container>
                          <ng-container matColumnDef="manage">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let customer" class="center-button">
                                  <button class="button button-red button-round" (click)="manageCustomerProgramEvent(customer)">
                                      &nbsp;Manage&nbsp;
                                  </button>
                              </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
                  </ng-container>
              </div>
            </div>
            <ng-template #customerProgramsSpinner>
              <div>
                <mat-spinner
                  mode="indeterminate"
                  class="circle"
                  diameter="60"
                  style="margin: auto; margin-top: 60px;"
                >
                </mat-spinner>
              </div>
            </ng-template>
          </div>
        </div>

      </div>


      <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id='levelOne' style="overflow-x: hidden;" *ngIf="narrowMode">
        <div style="height: 100%; display: flex">
            <div class="child-sidebar" style="border-right: 1px solid #dee2e6;">
                <div>
                    <child-header [title]="customer?.companyName" (closeEvent)="close()"></child-header>
                    <div class="child-body">
                        <div class="searchInputGroup">
                            <div class="searchIcon search-carts">
                                <img src="../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                        </div>

                        <ng-container *ngFor="let item of customerPrograms | TableFilter: 'programDescription' : searchField">
                            <div class="menu-wrapper" [class.active]="isActive(item?.programType, item?.cmsId)" (click)="manageCustomerProgramEvent(item)">
                                <label  class="small-title">{{item.programType}}</label>
                                    <a *ngIf="item?.cmsId" (click)="$event.stopPropagation()" [routerLink]="['/manageSubscriptions']"  [queryParams]="{cmsId:item?.cmsId}">
                                    <span class="basic-icon information-icon information-icon-position"></span>
                                </a>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="child-loader" *ngIf="showRest">
              <router-outlet></router-outlet>
            </div>
        </div>

      </div>
    </mat-sidenav-container>
</div>
<ng-template #dynamicInsert></ng-template>
<router-outlet  *ngIf="showRest2"></router-outlet>
